import { Component, OnInit, OnDestroy } from '@angular/core';

import {
  ApiService,
  CommonService,
  ApiUrlConstants
} from './shared/utils/imports';

import {
  Idle,
  DEFAULT_INTERRUPTSOURCES
} from '@ng-idle/core';

import { Router } from '@angular/router';

import {
  NotificationSignalRService
} from './shared/services/notification-signalr.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  public toasterData;
  public showToaster;
  public RefreshTimeOUT;

  // tslint:disable-next-line: ban-types
  public idleTimedOut: Boolean = false;


  constructor(
    private readonly api: ApiService,
    private readonly common: CommonService,
    private readonly router: Router,
    private idle: Idle,
    private readonly signalRService: NotificationSignalRService
  ) {

    /*
     * =========================================================
     * SESSION TIMEOUT TOASTER
     * =========================================================
     */
    this.common.timeoutCheck.subscribe(value => {

      if (value) {

        this.toasterData = {
          heading: 'SESSION TIMEOUT',
          buttonText: 'OK',
          type: 'TIMEOUT',
          showToaster: true
        };

        this.showToaster = true;

        this.common.setTimeoutValue(false);
      }
    });


    /*
     * =========================================================
     * USER TYPE CHANGE
     * =========================================================
     *
     * LoginComponent calls:
     *
     * this.common.setUserType(this.userType);
     *
     * This subscription handles:
     *
     * - Internal user
     * - External user
     * - Idle timeout
     * - SignalR startup
     * - API token refresh
     */
    this.common.userTypeCheck.subscribe(value => {

      const refreshToken =
        this.common.getRefreshToken();


      /*
       * =======================================================
       * INTERNAL USER
       * =======================================================
       */
      if (value === 'Internal') {

        /*
         * Internal users:
         * 59 minutes idle timeout.
         */
        this.idle.setIdle(3540);

        this.idlefunction();


        if (refreshToken) {

          console.log(
            'User logged in - AppComponent handling Internal user.'
          );


          /*
           * ---------------------------------------------------
           * START SIGNALR
           * ---------------------------------------------------
           *
           * NotificationSignalRService prevents duplicate
           * connections.
           */
          this.signalRService.startConnection();


          /*
           * ---------------------------------------------------
           * GET NEW API TOKEN
           * ---------------------------------------------------
           */
          this.getNewAPIToken();


          /*
           * ---------------------------------------------------
           * CLEAR EXISTING TOKEN TIMER
           * ---------------------------------------------------
           */
          if (this.RefreshTimeOUT) {

            clearInterval(
              this.RefreshTimeOUT
            );
          }


          /*
           * ---------------------------------------------------
           * REFRESH TOKEN EVERY 1 HOUR
           * ---------------------------------------------------
           */
          this.RefreshTimeOUT = setInterval(() => {

            this.getNewAPIToken();

          }, 3600000);
        }
      }


      /*
       * =======================================================
       * EXTERNAL USER
       * =======================================================
       */
      else if (value === 'External') {

        /*
         * External users:
         * 15 minutes idle timeout.
         */
        this.idle.setIdle(900);

        this.idlefunction();


        if (refreshToken) {

          console.log(
            'User logged in - AppComponent handling External user.'
          );


          /*
           * ---------------------------------------------------
           * START SIGNALR
           * ---------------------------------------------------
           */
          this.signalRService.startConnection();


          /*
           * ---------------------------------------------------
           * GET NEW API TOKEN
           * ---------------------------------------------------
           */
          // this.getNewAPIToken();


          /*
           * ---------------------------------------------------
           * CLEAR EXISTING TOKEN TIMER
           * ---------------------------------------------------
           */
          if (this.RefreshTimeOUT) {

            clearInterval(
              this.RefreshTimeOUT
            );
          }


          /*
           * ---------------------------------------------------
           * REFRESH TOKEN EVERY 16 MINUTES
           * ---------------------------------------------------
           */
          this.RefreshTimeOUT = setInterval(() => {

            this.getNewAPIToken();

          }, 960000);
        }
      }
    });
  }


  /**
   * =========================================================
   * APPLICATION INITIALIZATION
   * =========================================================
   *
   * IMPORTANT:
   *
   * We DO NOT call startConnection() here.
   *
   * SignalR is started from userTypeCheck after the
   * application knows whether the logged-in user is
   * Internal or External.
   *
   * This avoids two startConnection() calls during login.
   */
  ngOnInit() {

    console.log(
      '======================================'
    );

    console.log(
      'AppComponent initialized'
    );

    console.log(
      '======================================'
    );


    const refreshToken =
      this.common.getRefreshToken();


    if (refreshToken) {

      console.log(
        'Existing session found.'
      );

      console.log(
        'SignalR will start when user type/session is initialized.'
      );

    } else {

      console.log(
        'No refresh token.'
      );

      console.log(
        'SignalR will start after successful login.'
      );
    }
  }


  /**
   * =========================================================
   * IDLE FUNCTION
   * =========================================================
   */
  idlefunction() {

    /*
     * No additional timeout after idle event.
     */
    this.idle.setTimeout(0);


    /*
     * Reset interrupt sources.
     */
    this.idle.setInterrupts(
      DEFAULT_INTERRUPTSOURCES
    );


    /*
     * ---------------------------------------------------------
     * IDLE END
     * ---------------------------------------------------------
     */
    this.idle.onIdleEnd.subscribe(() => {

      /*
       * Nothing required here.
       */
    });


    /*
     * ---------------------------------------------------------
     * TIMEOUT
     * ---------------------------------------------------------
     */
    this.idle.onTimeout.subscribe(() => {

      this.idleTimedOut = true;
    });


    /*
     * ---------------------------------------------------------
     * IDLE START
     * ---------------------------------------------------------
     */
    this.idle.onIdleStart.subscribe(() => {

      console.log(
        'Session timeout: ' + new Date()
      );


      this.sessionTimeout();
    });


    /*
     * ---------------------------------------------------------
     * TIMEOUT WARNING
     * ---------------------------------------------------------
     */
    this.idle.onTimeoutWarning.subscribe(
      countdown => {

        /*
         * No warning logic currently required.
         */
      }
    );


    /*
     * Start idle watcher.
     */
    this.reset();
  }


  /**
   * =========================================================
   * SESSION TIMEOUT
   * =========================================================
   *
   * SignalR SHOULD be stopped here because this is an
   * intentional application shutdown.
   */
  sessionTimeout() {

    console.log(
      'Idle works'
    );


    /*
     * Show timeout toaster.
     */
    this.common.setTimeoutValue(true);


    /*
     * ---------------------------------------------------------
     * STOP SIGNALR
     * ---------------------------------------------------------
     *
     * IMPORTANT:
     *
     * Keep this.
     *
     * stopConnection() is for:
     *
     * - Session timeout
     * - Logout
     */
    console.log(
      'Stopping SignalR because session expired...'
    );


    this.signalRService.stopConnection();


    /*
     * ---------------------------------------------------------
     * CLEAR SESSION
     * ---------------------------------------------------------
     */
    sessionStorage.clear();


    /*
     * ---------------------------------------------------------
     * NAVIGATE TO LOGIN
     * ---------------------------------------------------------
     */
    this.router.navigate([
      '../login'
    ]);
  }


  /**
   * =========================================================
   * RESET IDLE WATCHER
   * =========================================================
   */
  reset() {

    this.idle.watch();

    this.idleTimedOut = false;
  }


  /**
   * =========================================================
   * CLOSE TOASTER
   * =========================================================
   */
  public closeToaster(event) {

    this.showToaster =
      event.showToaster;


    if (
      event.type === 'TIMEOUT'
    ) {

      this.common.setTimeoutValue(false);
    }
  }


  /**
   * =========================================================
   * GET NEW API TOKEN
   * =========================================================
   */
  public getNewAPIToken() {

    const refreshToken =
      this.common.getRefreshToken();


    /*
     * No refresh token.
     */
    if (!refreshToken) {

      console.log(
        'No refresh token available for API token refresh.'
      );

      return;
    }


    /*
     * Build refresh-token URL.
     */
    const url =
      ApiUrlConstants.URL.receiveRefreshTokenURL +
      '?refreshtoken=' +
      refreshToken;


    /*
     * Execute refresh request.
     */
    this.api.ExecuteGetRefresh(
      url,

      /*
       * -------------------------------------------------------
       * SUCCESS
       * -------------------------------------------------------
       */
      response => {

        if (
          response.ResponseCode === 200 &&
          response.Data
        ) {

          console.log(
            'API token refreshed successfully.'
          );


          /*
           * ---------------------------------------------------
           * UPDATE ACCESS TOKEN
           * ---------------------------------------------------
           */
          sessionStorage.setItem(
            'userToken',
            JSON.stringify(
              response.Data.AccessToken
            )
          );


          /*
           * ---------------------------------------------------
           * UPDATE REFRESH TOKEN
           * ---------------------------------------------------
           */
          sessionStorage.setItem(
            'refreshToken',
            JSON.stringify(
              response.Data.RefreshToken
            )
          );

        } else {

          console.warn(
            'API token refresh failed.',
            response
          );
        }
      },


      /*
       * -------------------------------------------------------
       * ERROR
       * -------------------------------------------------------
       */
      error => {

        console.error(
          'Refresh token failed.',
          error
        );
      }
    );
  }


  /**
   * =========================================================
   * APPLICATION DESTROYED
   * =========================================================
   */
  ngOnDestroy() {

    console.log(
      'AppComponent destroyed.'
    );


    /*
     * ---------------------------------------------------------
     * STOP IDLE WATCHER
     * ---------------------------------------------------------
     */
    this.idle.stop();


    /*
     * ---------------------------------------------------------
     * CLEAR TOKEN REFRESH TIMER
     * ---------------------------------------------------------
     */
    if (this.RefreshTimeOUT) {

      clearInterval(
        this.RefreshTimeOUT
      );

      this.RefreshTimeOUT = null;
    }


    /*
     * IMPORTANT:
     *
     * Do NOT call stopConnection() here.
     *
     * The NotificationSignalRService handles the browser
     * pagehide/pageshow lifecycle for BFCache.
     *
     * stopConnection() should be used explicitly for:
     *
     * - logout
     * - session timeout
     */
  }
}